import { render, staticRenderFns } from "./ClbrtnHistDetailBtn.vue?vue&type=template&id=1f2d4a64"
import script from "./ClbrtnHistDetailBtn.vue?vue&type=script&lang=js"
export * from "./ClbrtnHistDetailBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports